import React, { useState } from "react";
import { Home, FlaskConical, Receipt, ShoppingBag, FileText, Languages } from "lucide-react";
import { useBiz } from "./i18n";
import { SimpleOverview } from "./SimpleOverview";
import { Batches } from "./Batches";
import { ExpensesList } from "./ExpensesList";
import { SalesStock } from "./SalesStock";
import { Reports } from "./Reports";

const SECTIONS = [
  ["overview", Home, SimpleOverview],
  ["batches", FlaskConical, Batches],
  ["expenses", Receipt, ExpensesList],
  ["sales", ShoppingBag, SalesStock],
  ["reports", FileText, Reports],
];

export function BusinessTab() {
  const { t, lang, toggle } = useBiz();
  const [sec, setSec] = useState("overview");
  const Current = SECTIONS.find((s) => s[0] === sec)[2];
  return (
    <div dir={lang === "ar" ? "rtl" : "ltr"} data-testid="biz-root" className="bg-[#FAF7F2] text-[#1C1A17] rounded-3xl p-4 md:p-8 -mx-2 md:mx-0 font-sans">
      <div className="flex items-center justify-between gap-4 mb-5">
        <h1 className="text-2xl md:text-3xl font-semibold">{t("business")}</h1>
        <button onClick={toggle} data-testid="biz-lang-toggle" className="inline-flex items-center gap-1.5 text-sm text-[#6B645A] hover:text-[#1C1A17]">
          <Languages size={16} /> {lang === "ar" ? "English" : "العربية"}
        </button>
      </div>
      <nav className="flex gap-2 overflow-x-auto pb-2 mb-6 -mx-1 px-1">
        {SECTIONS.map(([id, Icon]) => (
          <button key={id} onClick={() => setSec(id)} data-testid={`biz-nav-${id}`}
            className={`flex items-center gap-2 rounded-full px-4 py-2.5 text-sm whitespace-nowrap transition-colors ${sec === id ? "bg-[#1C1A17] text-[#FAF7F2]" : "bg-white border border-[#EEE5D8] text-[#3A342C] hover:border-[#9A7445]"}`}>
            <Icon size={15} /> {t(id)}
          </button>
        ))}
      </nav>
      <Current />
    </div>
  );
}
